import GlobalNavigationShell from "components/v2/global-navigation-shell/GlobalNavigationShell";
import ShellProfileOverlay from "components/v2/shell-profile-overlay/ShellProfileOverlay";
import useDesktopChecker from "hooks/useDesktopChecker";
import useTabletChecker from "hooks/useTabletChecker";
import Application from "pages/application/Application";
import { getStepData } from "pages/application/question/questionSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeProfile } from "features/authSlice";
import ApplicationSidebarNav from "./ApplicationSidebarNav";
import "../shared-layout/shared-layout.scss";

const ApplicationShellLayout = () => {
  const dispatch = useDispatch();
  const isDesktop = useDesktopChecker();
  const isTablet = useTabletChecker();
  const isMobilePhone = !isDesktop && !isTablet;
  const { section: activeSection, sections } = useSelector(getStepData);

  useEffect(() => {
    dispatch(closeProfile());
  }, [dispatch]);

  const shellWrapperClassName = isDesktop
    ? "application-layout-context application-shell"
    : "application-shell application-shell--mobile";

  return (
    <div className={shellWrapperClassName}>
      <GlobalNavigationShell
        notificationsEnabled={false}
        shellContext="application"
        navSlot={
          !isMobilePhone ? (
            <ApplicationSidebarNav activeSection={activeSection} sections={sections} />
          ) : undefined
        }
        navSlotPlacement="sidebar"
      >
        <ShellProfileOverlay>
          <Application />
        </ShellProfileOverlay>
      </GlobalNavigationShell>
    </div>
  );
};

export default ApplicationShellLayout;
